import React from 'react';
import { CalendarCheck, Wallet } from 'lucide-react';
import { formatTrialDate, money } from '../../lib/walletDeposit.js';

/**
 * Explains the two different things on this step: a free 30-day platform trial
 * ($97/mo billed later) versus a prepaid telecom wallet deposit (not a fee).
 * @param {{trialEndDate: Date, amountUsd: number|null}} props
 * @returns {JSX.Element}
 */
export default function TrialDepositBanner({ trialEndDate, amountUsd }) {
  const when = formatTrialDate(trialEndDate);
  return (
    <div className="rounded-xl p-4 bg-civix-purple/10 border border-civix-purple/30 text-white/90 text-xs leading-relaxed space-y-2" data-testid="trial-banner">
      <div className="flex items-center gap-1.5 font-semibold text-white">
        <CalendarCheck className="w-4 h-4 text-civix-cyan" />
        Your 30-day free trial concludes on {when}
      </div>
      <p>
        <strong className="text-white">Platform subscription ($97/mo): $0 today.</strong>{' '}
        Your platform membership is 100% free for the first 30 days. Your card on file will not be billed
        for subscription fees until {when}. You can cancel anytime before then.
      </p>
      <p className="flex gap-1.5">
        <Wallet className="w-3.5 h-3.5 text-civix-cyan shrink-0 mt-0.5" />
        <span>
          <strong className="text-white">Prepaid telecom wallet:</strong>{' '}
          Your deposit today{amountUsd ? ` ($${money(amountUsd)})` : ''} is not a fee. It directly funds your personal
          telecom wallet balance to lease your dedicated phone lines ($1.00/line/mo) and power live calls and SMS messaging.
        </span>
      </p>
    </div>
  );
}
